module.exports = __webpack_public_path__ + "images/stickers/pete-vacation@2x.060295310e437200bf33.png";